import api from "./apiClient";

const BASE = process.env.VUE_APP_API_BASE_URL + "/api/v2/tipster/campanas";

export default {
  listar(tipsterId = null, periodo = 'todo') {
    const p = { periodo };
    if (tipsterId) p.tipster_id = tipsterId;
    return api.get(BASE, { params: p }).then((r) => r.data);
  },

  canalesFree(tipsterId = null) {
    const params = tipsterId ? { params: { tipster_id: tipsterId } } : {};
    return api.get(BASE + "/canales-free", params).then((r) => r.data);
  },

  landingPreview(slug, tipsterId = null) {
    const params = { slug, ...(tipsterId ? { tipster_id: tipsterId } : {}) };
    return api.get(BASE + "/landing-preview", { params }).then((r) => r.data);
  },

  detalle(campanaId, tipo, moneda = null, tipsterId = null) {
    const params = { campana_id: campanaId, tipo, ...(moneda ? { moneda } : {}), ...(tipsterId ? { tipster_id: tipsterId } : {}) };
    return api.get(BASE + "/detalle", { params }).then((r) => r.data);
  },

  crearEnlace(payload) {
    return api.post(BASE + "/crear-enlace", payload).then((r) => r.data);
  },

  borrarEnlace(id, tipsterId = null) {
    return api.post(BASE + "/borrar-enlace", { id, ...(tipsterId ? { tipster_id: tipsterId } : {}) }).then((r) => r.data);
  },
};
